import { useEffect, useRef, useCallback } from "react";
import { BACKEND_URL } from "@/lib/api";

export function useWebSocket(enabled, onMessage) {
  const wsRef = useRef(null);
  const onMessageRef = useRef(onMessage);
  onMessageRef.current = onMessage;

  const connect = useCallback(() => {
    if (!enabled) return;
    const wsUrl = BACKEND_URL.replace(/^http/, "ws") + "/api/ws";
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data);
        onMessageRef.current?.(parsed);
      } catch (e) {
        console.error("Failed to parse WebSocket message:", e);
      }
    };

    ws.onclose = () => {
      wsRef.current = null;
      setTimeout(() => {
        if (enabled) connect();
      }, 4000);
    };

    return ws;
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    connect();
    return () => {
      wsRef.current?.close();
    };
  }, [enabled, connect]);

  return wsRef;
}
